import { MetricUnit } from '@/__generated__/graphql';
import { Formatters } from '@/hooks/useFormatters';

export const formatPosition = (
  position: number,
  formatMetricValue: Formatters['formatMetricValue'],
) => {
  return formatMetricValue(position, {
    unit: MetricUnit.Centimeter,
    precision: 1,
  });
};
